import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setPigletHerdDetails, setPigletHerdDetailsAdmin } from "services";

import { footprintingPigletPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PIGLET_HERD_DETAILS } from "consts";

import { FootprintingPigletHerdDetails } from "models";

export const useMutateFootprintingPigletHerdDetails = (
  farmId: string,
  year: number,
  payload: Partial<Omit<FootprintingPigletHerdDetails, "id" | "primaryDataId">>,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_PIGLET_HERD_DETAILS, primaryDataId, isAdmin],
    mutationFn: () => (isAdmin ? setPigletHerdDetailsAdmin(payload, primaryDataId ?? "") : setPigletHerdDetails(payload, primaryDataId ?? "")),
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_PIGLET_HERD_DETAILS, primaryDataId, isAdmin],
        [FOOTPRINTING_PIGLET_HERD_DETAILS, farmId, year, isAdmin],
        ...footprintingPigletPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
      ]);
    },
  });
};
